<!-- Navbar -->
<app-navbar-style-three></app-navbar-style-three>
<!-- End Navbar -->

<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="title-item">
                    <h2>Terms & Conditions</h2>
                    <ul>
                        <li>
                            <img src="assets/img/home-three/title-img-two.png" alt="Image">
                            <a routerLink="/">Home</a>
                        </li>
                        <li><span>/</span></li>
                        <li>Terms & Conditions</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page Title -->

<!-- Terms & Conditions -->
<div class="rules-area ptb-100">
    <div class="container">
        <div class="rules-item">
            <h3>1 - Agreement Of User</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas porro amet consequuntur in voluptatum perspiciatis, nostrum deserunt quos accusamus, eos optio recusandae eius facilis voluptatibus expedita numquam eaque praesentium laboriosam.</p>

            <h3>2 - Access And Use Of The Site</h3>
            <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. As opposed to using 'Content here, content here.</p>

            <h3>3 - Copyright Infringement</h3>
            <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.</p>

            <h3>4 - Access And Interference</h3>
            <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum. But the majority have suffered alteration in some form, by injected humour.</p>

            <h3>5 - Limitation Of Liability</h3>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting.</p>
        </div>
    </div>
</div>
<!-- End Terms & Conditions -->

<!-- Footer -->
<app-footer-style-two></app-footer-style-two>
<!-- End Footer -->